import axios from 'axios';
import constants from './../../components/constants/constants';
import {getEnvironment} from "./../../components/utils/environmantDetection";

function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(
        /[?&]+([^=&]+)=([^&]*)/gi,
        function (m, key, value) {
            vars[key] = value;
        }
    );
    return vars;
}

const shareService = {
    getShareServiceURL: function () {
        return axios.get(constants.SHARE_WIDGET_VERSION);
    },

    sendEmail: function (options, token) {
        console.log('getUrlVars()', getUrlVars());
        let url = `https://${getEnvironment('API')}shutterfly.com/share/v1/email/${getUrlVars().shareid}`
        var emailAddresses = [];
        options.recipients.forEach(function (recipient) {
            emailAddresses.push(recipient.email);
        });
        var payload = {
            emailAddresses: emailAddresses,
            emailBody: options.message,
            sharedBy: options.sharedBy
        };
        return axios.post(
            url,
            payload,
            {
                headers: {
                    Authorization: 'Bearer ' + token
                }
            }
        );
    }
}

export default shareService;